// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';

import Default from './Default.vue';
import Public from './Public.vue';

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import './axios';


delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
	iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
	iconUrl: require('leaflet/dist/images/marker-icon.png'),
	shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

Vue.use(BootstrapVue);

//All icons
Vue.use(IconsPlugin);

// turn off annoying tips
Vue.config.productionTip = false;

// different layouts for meta layout in routes
Vue.component('default-layout', Default);
Vue.component('public-layout', Public);

// decide what to do with authorisation and routes, intercept request and check for access
router.beforeEach((to, from, next) => {

	if (to.matched.some(record => record.meta.requiresAuth)) {

		// ping api for 200 or 401. This will alter the watched "getAuth" in the store, auto logging them out before they can see the page.
		store.dispatch('getPing');

		// fetch the session auth stuff for each request so we can see if they are allowed access.
		let userInfo = store.getters.userInfo;
		let auth = store.getters.isAuthenticated;

		// are they logged in?
		if (!auth) {
			next({
				path: '/login',
				query: { nextUrl: to.fullPath }
			});
		} else {
			// does their role let them access this page?
			if (to.matched.some(record => record.meta.allowedRoles)) {
				let allowedRoles = to.meta.allowedRoles;
				let userRole = userInfo.Role;
				if (allowedRoles.includes(userRole)) {
					next();
				} else {
					next({ name: 'accessDenied' });
				}
			} else {
				next();
			}
		}
	} else if (to.matched.some(record => record.meta.guest)) {
		if (!auth) {
			next();
		}
		else {
			next({
				name: 'public'
			});
		}
	} else {
		next();
	}
});

new Vue({
	store,
	el: '#app',
	router,
	components: { App },
	template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js